<!-- 添加 & 编辑拜访记录 -->
<template>
  <!--添加界面-->
  <el-dialog class="model-visit-form" width="850px" :title="title" :visible="myVisible" :destroy-on-close="true"
    @close="handerClose" :close-on-click-modal="false">
    <el-row :gutter="24" class="toolbar">
      <el-form :model="ruleForm" :rules="rules" label-width="100px" label-position="left" ref="ruleForm">
        <el-col :span="12">
          <el-form-item label="拜访客户" prop="companyName">
            <el-input v-model="ruleForm.companyName" placeholder="请输入" disabled></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="客户经理" prop="adminUser">
            <SelectCommon placeholder="请选择" style="width: 100%" disabled
              :defaultVal="ruleForm.adminUser ? ruleForm.adminUser : undefined" apiPath="/tbAdminuser/manageList"
              :keys="{ label: 'name', value: 'id' }" 
              :selectFirst="userInfo.type == '2'" :params="{ ComId: companyId }"
              @change="(value, datas) => handleSelectCommon(value, datas, 'adminUser')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户成功经理">
            <SelectCommon placeholder="请选择" style="width:100%" :clearable="true" disabled apiPath="/tbCompany/getInfoById"
              :params="{ type: 3 ,id: companyId }" :keys="{ label: 'successfulManagerName', value: 'successfulManager' }" :defaultVal="ruleForm.successfulManager" 
              :selectFirst="userInfo.type == '3'"
              @change="(value, datas) => handleSelectCommonFilter(value, datas, 'successfulManager')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经销商">
            <SelectCommon placeholder="请选择" style="width: 100%" :clearable="true" disabled apiPath="/tbCompany/getInfoById"
              :params="{ type: 4,id: companyId  }" :keys="{ label: 'agencyManagerName', value: 'agencyManager' }" :defaultVal="ruleForm.agencyManager" 
              :selectFirst="userInfo.type == '4'"
              @change="(value, datas) =>handleSelectCommonFilter(value, datas, 'agencyManager')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="拜访日期" prop="payVisitDate">
            <el-date-picker type="date" placeholder="请选择" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              v-model="ruleForm.payVisitDate" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="联系人" prop="contactUser">
            <el-input v-model="ruleForm.contactUser" placeholder="请输入"></el-input>
          <!-- <SelectCommon  placeholder="请选择" style="width: 100%" :clearable="true" 
                                :defaultVal="ruleForm.contactUser? ruleForm.contactUser: undefined"
                                 apiPath="/tbCompany/getCompanyUser" 
                                 :keys="{label: 'name', value: 'id'}" 
                                 :params="{ companyId: $route.query.companyId }"
                                   @change="(value, datas) => handleSelectCommon(value, datas, 'contactUser')" /> -->
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="联系方式" prop="contactPhone">
            <el-input v-model="ruleForm.contactPhone" placeholder="请输入"
              oninput="this.value=this.value.replace(/[^\d]/g,'');"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="职位" prop="position">
            <el-input v-model="ruleForm.position" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="拜访详情" prop="payVisitInfo">
            <el-input type="textarea" rows="3" v-model="ruleForm.payVisitInfo" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="拜访方式：" prop="payVisitStatus">
            <el-select v-model="ruleForm.payVisitStatus" placeholder="拜访状态" style="width:100%;">
              <el-option v-for="item in visitStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <!--  :on-preview="handlePictureCardPreview" -->
          <el-form-item label="现场照片" prop="pic" v-if="ruleForm.payVisitStatus == 2 || ruleForm.payVisitStatus == 3">
            <el-upload ref="upload" size="small" class="avatar-uploader" multiple
              accept="image/png,image/jpg,image/jpeg,image/gif" :auto-upload="false" action="" :on-remove="handleRemove"
              :on-change="handerUploadChange" :file-list="fileList" list-type="picture-card">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>

      </el-form>
    </el-row>

    <div slot="footer" class="dialog-footer" style="text-align:center">
      <el-button @click.native="handerClose">取消</el-button>
      <el-button type="primary" @click.native="handerSubmit" :loading="confirmLoading">提交</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { API_userCom, API_Common, } from '@/api/index.js'
import utils from '@/utils/index'
import SelectCommon from '@/components/SelectCommon'
import GisCommon from '@/components/GisCommon'
import { toUserCoordinate } from 'ol/proj'
export default {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    visitStatusList: {
      type: Array,
      default: () => { }
    },
    processDetail: {
      type: Object,
      default: () => null
    }
  },

  data() {
    var validateFile = (rule, value, callback) => {
      if (!this.ruleForm.pic) {
        callback(new Error('请上传现场照片'));
      } else {
        callback();
      }
    }
    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      companyList: [],
      title: '',

      selectedUserId: [],

      rules: {
        departName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],

        payVisitDate: [
          { required: true, message: '请选择拜访日期', trigger: 'change' }
        ],

        // adminUser: [
        //   // { required: true, validator: validateManager, }
        //   { required: true, message: '请选择客户经理', trigger: 'change' }
        // ],

        contactUser: [
          // { required: true, validator: validateContactUser,  }
          { required: true, message: '请输入联系人', trigger: 'change' }
        ],

        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],

        position: [
          { required: true, message: '请输入职位', trigger: 'blur' }
        ],

        payVisitInfo: [
          { required: true, message: '请输入拜访详情', trigger: 'blur' }
        ],

        payVisitStatus: [
          { required: true, message: '请选择拜访状态', trigger: 'blur' }
        ],

        // pic: [
        //   { required: true, validator: validateFile, trigger: 'change' }
        // ],

      },

      ruleForm: {
        companyName: this.$route.query.companyName,
        companyId: this.$route.query.companyId,
        adminUser: '',         // 客户经理
        payVisitDate: '',      // 拜访日期
        contactUser: '',       // 联系人
        contactPhone: '',      // 联系方式
        position: '',          // 职位
        payVisitInfo: '',      // 拜访详情
        payVisitStatus: '',      // 拜访状态： 1电话沟通、2客户现场、3视频会议
        successfulManager:"",  //客户成功经理
        agencyManager:"",      //经销商
        pic: '',
      },

      companyId: this.$route.query.companyId,
      fileList: [],
      removeUploadFileIds: [],   // 记录编辑已上传的文件： 编辑时被删除的图片
      uploadURL: '',


    };
  },

  components: {
    SelectCommon,
    GisCommon
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },

  created() {
    this.myVisible = this.visible
  },

  mounted() {
    let { token, checkCode } = utils.getParamsByCookie();
    this.token = token;
    this.checkCode = checkCode;

    if (this.mode == 'save') {
      this.title = '新增'
    } else {
      this.title = '编辑'
      let myDetail = JSON.parse(JSON.stringify(this.processDetail))
      myDetail.auditStatus = myDetail.auditStatus + ''
      myDetail.payVisitStatus = myDetail.payVisitStatus + ''
      // 已上传被删除的图片如何处理？
      let fileList = myDetail.picList;
      fileList.forEach(item => {
        item.uid = item.id
        item.name = item.fileName
        item.url = item.sltUrl
      })
      myDetail.picList = fileList
      this.fileList = fileList
      this.ruleForm = { ...this.ruleForm, ...myDetail }
    }

  },

  methods: {

    // 选择图片
    handerUploadChange(file, fileList) {
      // console.log('file,fileList===handerUploadChange', file,fileList)
      this.fileList.push(file)
      this.ruleForm.pic = this.fileList.length > 0 ? (this.fileList.map(item => item.uid).join()) : ''
      this.$refs.ruleForm.validateField('pic');
    },

    handlePictureCardPreview(file) {
      console.log("remove==")
    },

    // 删除图片
    handleRemove(file, fileList) {
      // console.log('remove==',  file, fileList);
      this.fileList = this.fileList.filter(item => item.uid != file.uid)
      this.ruleForm.pic = this.fileList.length > 0 ? (this.fileList.map(item => item.uid).join()) : '';

      // 删除时记录下文件id， 提交时统一删除
      if (file.id) {
        this.removeUploadFileIds.push(file.id);
      }

      this.$refs.ruleForm.validateField('pic');
    },


    // 客户经理
    handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0]
      this.$refs.ruleForm.validateField(key);
      if (key === 'contactUser') {
        this.ruleForm.contactPhone = datas[0].phone
      }
    },

    handleSelectCommonFilter(value, datas, key){
      this.ruleForm[key]=value[0]
    },

    submitUpload() {
      this.$refs.upload.submit();
    },


    uploadPic(formData) {
      return API_userCom.uploadPic(formData).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data
          let picIds = data.length > 0 ? data.map(item => item.id).join() : ''
          return picIds;
        } else {
          this.$message.error('上传图片出错');
        }
        return false;
      }).catch(err => {
        this.confirmLoading = false;
        this.$message.error('上传图片出错');
        return false;
      })
    },

    delPic() {
      let data = {
        picId: this.removeUploadFileIds.join(),
        id: this.ruleForm.id
      }
      return API_userCom.delPic(data).then(res => {
        if (res.data.code == 200) {
          return true;
        } else {
          this.$message.error('删除图片出错');
        }
        return false;
      }).catch(err => {
        this.confirmLoading = false;
        this.$message.error('删除图片出错');
        return false;
      })
    },



    handerSubmit(formName) {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          let data = { ...this.ruleForm }
          data.createUser = this.userInfo.id;
          delete data.companyName;
          this.confirmLoading = true;
          // 待上传图片
          let fileRawList = this.fileList.filter(item => item.raw)
          // 客户现场必须上传现场图片 2、有图片更新 && fileRawList.length > 0
          if (data.payVisitStatus == 2 || data.payVisitStatus == 3) {
            // 删除
            if (this.removeUploadFileIds.length > 0) {
              let res = await this.delPic()
              if (!res) {
                return;
              }
            }

            // 上传
            if (fileRawList.length > 0) {
              let formData = new FormData()
              fileRawList.map(item => {
                formData.append('pic', item.raw)
              })
              let picIds = await this.uploadPic(formData);
              if (picIds) {
                data.pic = picIds
                this.mode == 'save' ? this.handerSave(data) : this.handerUpdate(data)
              }
            } else {
              this.mode == 'save' ? this.handerSave(data) : this.handerUpdate(data)
            }

          } else {
            this.confirmLoading = true;
            this.mode == 'save' ? this.handerSave(data) : this.handerUpdate(data)
          }


        }
      });
    },

    handerSave(data) {
      data.payVisitDate = data.payVisitDate + ' 00:00:00'
      API_userCom.addTrack(data).then(res => {
        if (res.data.code == 200) {
          this.$message.success('新增成功');
          this.$emit('getList')
          this.handerClose();
        }
        this.confirmLoading = false;
      }).catch(err => {
        this.confirmLoading = false;
      })
    },

    handerUpdate(data) {
      let date = data.payVisitDate;
      data.payVisitDate = date.indexOf('00:00:00') > -1 ? date : (date + ' 00:00:00')
      delete data.contactUserName;
      delete data.adminUserName;
      API_userCom.updateTrack(data).then(res => {
        if (res.data.code == 200) {
          this.$message.success('编辑成功');
          this.$emit('getList')
          this.handerClose();
        }
        this.confirmLoading = false;
      }).catch(err => {
        this.confirmLoading = false;
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false)
    },

  },

}

</script>
<style lang='scss'>
.model-visit-form {
  .avatar-uploader {
    display: flex;
    // flex-direction: column;
  }

  .el-upload {
    width: 100px;
    order: 1;
    // margin-bottom: 8px;
    margin-right: 8px;
  }

  .el-upload-list {
    flex: 1;
    min-width: 1px;
    order: 2
  }

  .el-upload--picture-card,
  .avatar-uploader-icon {
    width: 100px;
    height: 100px;
    line-height: 100px;
    color: #999;
  }

  .el-upload--picture-card {
    background: #fff;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #f66b3d;
  }

  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// ModalForm.vue?44be0b90